import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ALAIN_I18N_TOKEN, I18nPipe } from '@delon/theme';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { finalize } from 'rxjs';
import { I18NService } from 'src/app/core/i18n/i18n.service';
import { HttpService } from 'src/app/http/http.service';
import { ChannelService } from 'src/app/services/channel.service';
import { FacebookService } from 'src/app/services/facebook.service';
import { InstagramService, InstagramUser } from 'src/app/services/instagram.service';
import { SystemConfigService } from 'src/app/services/system-config.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { showFallbackHttpError } from 'src/app/shared/utils/http-error-toast.util';
import { ConstantUtil } from 'src/app/util/constant.util';

import { ChannelErrorReportComponent } from './channel-error-report/channel-error-report.component';

interface ChannelConfig {
  type: CHANNEL_TYPE;
  name: string;
  enabled: boolean;
  config: {
    providerId: string | null;
    channelSecret: string | null;
    botBasicId: string | null;
    businessCardLiffId: string | null;
    channel: string;
    channelId: string;
    channelType: string | null;
    code: string | null;
    groupCode: string | null;
    ig_botName: string | null;
    ig_name: string | null;
    joinAileLiffId: string | null;
    lineChannelType: string | null;
    liffId: string | null;
    memberId: string | null;
    messageRemainCount: number | null;
    messageTotalCount: number | null;
    messageUsedCount: number | null;
    name: string | null;
    pictureUrl: string | null;
    accessToken: string | null;
    avatarUrl: string | null;
    serviceNumberId: string;
    status: string | null;
    tenantId: string | null;
    bindErrorCode: string | null;
    bindErrorMessage: string | null;
    gwBindingDeleted: boolean | null;
    webhookUrl: string;
    groupName: string | null;
    allowLineGroupSend: boolean | null;
  };
}
export enum CHANNEL_TYPE {
  LINE_LOGIN = 'LINE Login',
  LINE_OA = 'LINE OA',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  UNDEFINED = 'UNDEFINED'
}

@Component({
  selector: 'personal-channel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzCardModule,
    NzDividerModule,
    NzGridModule,
    NzIconModule,
    NzModalModule,
    NzSelectModule,
    NzSpinModule,
    NzSwitchModule,
    NzToolTipModule,
    NzDropDownModule,
    NzAvatarModule,
    NzTagModule,
    NzTableModule,
    NzRadioModule,
    NzPopoverModule,
    NzAlertModule,
    ChannelErrorReportComponent,
    I18nPipe,
    TestIdDirective
  ],
  templateUrl: './personal-channel.component.html',
  styleUrls: ['./personal-channel.component.less']
})
export class PersonalChannelComponent implements OnInit, OnDestroy {
  @ViewChild('errorReportComponent') errorReportComponent!: ChannelErrorReportComponent;
  private readonly fb = inject(FormBuilder);
  private readonly route = inject(ActivatedRoute);
  private readonly httpService = inject(HttpService);
  private readonly message = inject(NzMessageService);
  private readonly systemConfigService = inject(SystemConfigService);
  private readonly modal = inject(NzModalService);
  private readonly facebookService = inject(FacebookService);
  private readonly instagramService = inject(InstagramService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly channelService = inject(ChannelService);
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  readonly CHANNEL_TYPE = CHANNEL_TYPE;

  tenantId: string = '';
  officialServiceNumberId: string = '';
  serviceNumberId: string = '';
  loading = false;
  client_id: string = '';
  fbRedirect_url: string = `${window.location.origin}/checkFBLogin`;
  igRedirect_url: string = `${window.location.origin}/checkIGLogin`;
  //igRedirect_url: string = 'https://aile-admin-dev.web.app/checkIGLogin';
  oauthUrl: string = '';
  showSuccessAlert = false;

  // 渠道配置
  channels: ChannelConfig[] = [];

  // 模态框状态
  modalVisible = false;
  lineGuideVisible = false;
  currentChannel: ChannelConfig | null = null;
  channelForm: FormGroup;

  // Facebook相关属性
  facebookLoginLoading = false;
  bindingLoading = false;
  bindingChannelType = '';

  // Instagram相关属性
  instagramLoginLoading = false;
  instagramLoginPopup: Window | null = null;

  // 添加查看模式标识
  isViewMode = false;
  unbindingLoading = false;
  unbindingChannelType = '';
  lineGroupSendUpdating = false;
  dropdownVisible = false;

  // 防护机制：防止重复处理消息和API请求
  private isProcessingMessage = false;
  private processedMessageIds = new Set<string>();
  private lastBindRequestTime = 0;
  private readonly BIND_REQUEST_DEBOUNCE_TIME = 2000; // 2秒防抖
  private readonly facebookMessageTypes = new Set(['BIND_SUCCESS', 'BIND_ERROR', 'PAGE_SELECTED', 'BIND_CANCELLED']);
  private readonly instagramMessageTypes = new Set(['INSTAGRAM_LOGIN_SUCCESS', 'INSTAGRAM_LOGIN_ERROR']);
  private readonly boundMessageHandler = (event: MessageEvent) => this.handleMessage(event);
  private readonly boundInstagramMessageHandler = (event: MessageEvent) => this.handleInstagramMessage(event);
  readonly iosSpinnerTicks = Array.from({ length: 12 }, (_, index) => index);

  constructor() {
    this.channelForm = this.fb.group({
      providerId: [''],
      channelId: [''],
      channelSecret: [''],
      pageId: [''],
      pageName: [''],
      accessToken: ['']
    });
  }

  ngOnInit(): void {
    this.route.parent?.params.subscribe(params => {
      this.tenantId = params['id'];
      if (this.tenantId === localStorage.getItem('current_tenant_id')) {
        this.officialServiceNumberId = localStorage.getItem('current_tenant_officialServiceNumberId') ?? '';
      }
      this.serviceNumberId = localStorage.getItem('current_tenant_boss_snid') ?? '';
      this.loadChannelConfigs();
      this.loadFacebookAppId();
    });

    // 添加 postMessage 监听器
    this.setupMessageListener();
    this.setupInstagramMessageListener();
  }

  ngOnDestroy(): void {
    // 清理Instagram弹窗
    if (this.instagramLoginPopup && !this.instagramLoginPopup.closed) {
      this.instagramLoginPopup.close();
    }
    // 移除 postMessage 監聽器
    window.removeEventListener('message', this.boundMessageHandler);
    // 移除Instagram消息监听器
    window.removeEventListener('message', this.boundInstagramMessageHandler);

    // 清理防护机制的资源
    this.processedMessageIds.clear();
    this.isProcessingMessage = false;
    this.lastBindRequestTime = 0;
  }

  // 設置 postMessage 監聽器
  private setupMessageListener(): void {
    window.addEventListener('message', this.boundMessageHandler);
  }

  // 處理來自 facebook-callback 窗口的消息
  private handleMessage(event: MessageEvent): void {
    // 驗證來源
    if (event.origin !== window.location.origin) {
      return;
    }

    const data = event.data;
    if (!data?.type || !this.facebookMessageTypes.has(data.type)) {
      return;
    }

    // 防护1: 检查是否正在处理消息
    if (this.isProcessingMessage) {
      console.log('Message processing in progress, ignoring duplicate message');
      return;
    }

    // 防护2: 生成消息ID并检查是否已处理过
    const messageId = this.buildMessageDedupKey(data, 'facebook');
    if (this.processedMessageIds.has(messageId)) {
      console.log('Message already processed, ignoring duplicate:', messageId);
      return;
    }

    // 防护3: 对于PAGE_SELECTED类型，检查防抖时间
    if (data.type === 'PAGE_SELECTED') {
      const now = Date.now();
      if (now - this.lastBindRequestTime < this.BIND_REQUEST_DEBOUNCE_TIME) {
        console.log('Bind request too frequent, ignoring');
        return;
      }
      this.lastBindRequestTime = now;
    }

    // 标记正在处理消息
    this.isProcessingMessage = true;
    this.processedMessageIds.add(messageId);

    try {
      if (data.type === 'BIND_SUCCESS') {
        this.message.success(this.getChannelSubmittedMessage());
        this.loadChannelConfigs(); // 重新加載渠道配置
        this.facebookLoginLoading = false;
        this.bindingLoading = false;
      } else if (data.type === 'BIND_ERROR') {
        // Facebook 串接失敗
        this.logBindErrorDetail(data);
        this.message.error(data.message || this.getChannelFailureMessage(data.channelType));
        this.facebookLoginLoading = false;
        this.bindingLoading = false;
      } else if (data.type === 'PAGE_SELECTED') {
        // 不要在此处设置 bindingLoading，避免 bindPages 的防护提前拦截首个请求
        this.bindingChannelType = data.channelType;
        this.bindPages(data.pageData, data.channelType);
      } else if (data.type === 'BIND_CANCELLED') {
        // 用戶取消串接
        this.facebookLoginLoading = false;
        this.bindingLoading = false;
      }
    } finally {
      // 延迟重置处理状态，防止快速连续消息
      setTimeout(() => {
        this.isProcessingMessage = false;
      }, 500);
    }

    // 清理过期的消息ID（保留最近10分钟的记录）
    setTimeout(() => {
      this.processedMessageIds.delete(messageId);
    }, 600000);
  }

  private logBindErrorDetail(data: any): void {
    if (!data?.errorDetail) {
      return;
    }

    console.error('Facebook bind error detail:', data.errorDetail, {
      errorType: data.errorType,
      message: data.message,
      errorDetail: data.errorDetail
    });
  }

  // 串接 Facebook Instagram頁面
  private bindPages(pageData: any, channelType: string): void {
    // 防护4: 检查是否已经在进行绑定操作
    if (this.bindingLoading) {
      console.log('Binding already in progress, ignoring duplicate request');
      return;
    }

    // 防护5: 检查页面数据是否有效
    if (!pageData) {
      console.log('No page data to bind');
      this.message.warning(this.i18n.fanyi('tenant.channel.callback.select-page-required'));
      return;
    }

    // 根據渠道類型構建不同的數據結構
    const bindData: any = {
      serviceNumberId: this.serviceNumberId,
      channelType: channelType
    };
    console.log(pageData);
    // 根據渠道類型設置不同的 DTO 參數名稱
    if (channelType === 'Instagram') {
      bindData.instagramDto = {
        code: pageData.id,
        // accessToken: pageData.fansPage_access_token,
        accessToken: pageData.accessToken,
        serviceNumberId: this.serviceNumberId,
        //  groupCode: pageData.fansPageId,
        //  groupName: pageData.fansPageName,
        pictureUrl: pageData.pictureUrl
      };
    } else {
      bindData.facebookDto = {
        code: pageData.id,
        accessToken: pageData.access_token,
        serviceNumberId: this.serviceNumberId,
        pictureUrl: pageData.picture?.data?.url
      };
    }

    // 设置绑定状态，防止重复请求
    this.bindingLoading = true;
    this.bindingChannelType = channelType;

    this.channelService
      .bindChannel(bindData)
      .pipe(
        finalize(() => {
          this.facebookLoginLoading = false;
          this.bindingLoading = false;
          this.bindingChannelType = '';
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.message.success(this.getChannelSubmittedMessage());
            // 防护6: 延迟重新加载配置，避免与绑定请求冲突
            setTimeout(() => {
              this.loadChannelConfigs();
            }, 1000);
          } else {
            showFallbackHttpError(this.message, res.msg, this.getChannelFailureMessage(channelType));
          }
        },
        error: error => {
          console.error('Channel bind error:', error);
          this.message.error(this.getChannelFailureMessage(channelType));
          this.errorReportComponent.showConnectionErrorModal();
        }
      });
  }

  // 检查渠道是否禁用
  isChannelDisabled(type: string): boolean {
    if (type === CHANNEL_TYPE.LINE_OA) {
      return !this.hasChannelType(CHANNEL_TYPE.LINE_LOGIN);
    }
    return false;
  }

  isChannelConnectDisabled(type: string): boolean {
    const channel = this.getChannelByType(type);
    const status = channel?.config.status;
    if (status === 'Binding' || status === 'Initializing') {
      return true;
    }
    if (status === 'Failed' && type === CHANNEL_TYPE.LINE_LOGIN) {
      return channel?.config.gwBindingDeleted !== true;
    }
    return this.isChannelDisabled(type);
  }

  // 检查是否还有可连接的渠道
  hasAvailableChannelsToConnect(): boolean {
    const allChannelTypes = [CHANNEL_TYPE.LINE_OA, CHANNEL_TYPE.LINE_LOGIN, CHANNEL_TYPE.Facebook, CHANNEL_TYPE.Instagram];

    return allChannelTypes.some(type => !this.hasChannelType(type));
  }

  // 检查是否已存在指定类型的渠道
  hasChannelType(type: string): boolean {
    const channel = this.getChannelByType(type);
    if (!channel) {
      return false;
    }
    return this.isChannelAvailable(channel);
  }

  shouldShowChannelUnbindAction(type: string): boolean {
    const channel = this.getChannelByType(type);
    if (!channel) {
      return false;
    }
    if (this.isChannelAvailable(channel)) {
      return true;
    }
    return channel.config.status === 'Failed' && this.hasSocialChannelBindingData(channel);
  }

  private hasSocialChannelBindingData(channel: ChannelConfig): boolean {
    if (channel.type !== CHANNEL_TYPE.Facebook && channel.type !== CHANNEL_TYPE.Instagram) {
      return false;
    }
    const config = channel.config;
    return !!(config.code || config.channelId || config.serviceNumberId || config.accessToken || config.memberId);
  }

  hasLineLoginBindingData(): boolean {
    const config = this.getChannelByType(CHANNEL_TYPE.LINE_LOGIN)?.config;
    return !!(config?.channelId || config?.providerId || config?.serviceNumberId);
  }

  getLineLoginStatusText(): string {
    return this.getChannelStatusText(CHANNEL_TYPE.LINE_LOGIN);
  }

  getChannelStatusText(type: string): string {
    const channel = this.getChannelByType(type);
    const status = channel?.config.status;
    if (!status || status === 'Available') {
      return '';
    }
    if (status === 'Failed') {
      return this.i18n.fanyi('tenant.channel.personal.line-login.status.Failed');
    }
    const statusText = this.i18n.fanyi(`tenant.channel.personal.line-login.status.${status}`);
    return statusText === `tenant.channel.personal.line-login.status.${status}` ? status : statusText;
  }

  getLineLoginStatusClass(): string {
    return this.getChannelStatusClass(CHANNEL_TYPE.LINE_LOGIN);
  }

  getChannelStatusClass(type: string): string {
    const status = this.getChannelByType(type)?.config.status;
    if (status === 'Failed') {
      return 'card-status--danger';
    }
    return '';
  }

  getLineLoginFailureReason(): string {
    return this.getChannelFailureReason(CHANNEL_TYPE.LINE_LOGIN);
  }

  getChannelFailureReason(type: string): string {
    const channel = this.getChannelByType(type);
    if (channel?.config.status !== 'Failed') {
      return '';
    }
    const rebindKey = 'tenant.channel.personal.line-login.rebind-hint';
    const translatedRebindHint = this.i18n.fanyi(rebindKey);
    const rebindHint = translatedRebindHint === rebindKey ? '请重新绑定。' : translatedRebindHint;
    const reason = channel.config.bindErrorMessage;
    if (!reason) {
      return rebindHint;
    }
    return /[。.!?！？]$/.test(reason) ? `${reason}${rebindHint}` : `${reason}。${rebindHint}`;
  }

  private getChannelByType(type: string): ChannelConfig | undefined {
    return this.channels.find(channel => channel.type === type);
  }

  private isChannelAvailable(channel: ChannelConfig): boolean {
    const status = channel.config.status;
    if (!status) {
      return true;
    }
    return status === 'Available';
  }

  // 获取渠道名称
  private getChannelTitleName(type: CHANNEL_TYPE): string {
    const nameMap: { [key in CHANNEL_TYPE]: string } = {
      [CHANNEL_TYPE.LINE_OA]: this.i18n.fanyi('tenant.channel.personal.line-oa-name'),
      [CHANNEL_TYPE.LINE_LOGIN]: this.i18n.fanyi('tenant.channel.personal.line-login-name'),
      [CHANNEL_TYPE.Facebook]: this.i18n.fanyi('tenant.channel.personal.facebook-name'),
      [CHANNEL_TYPE.Instagram]: this.i18n.fanyi('tenant.channel.personal.instagram-name'),
      [CHANNEL_TYPE.UNDEFINED]: ''
    };
    return nameMap[type];
  }

  // 打开空的模态框用于绑定
  openChannelModal(type: CHANNEL_TYPE): void {
    this.currentChannel = {
      type,
      name: this.getChannelTitleName(type),
      enabled: true,
      config: {
        channelSecret: null,
        botBasicId: null,
        providerId: null,
        businessCardLiffId: null,
        channel: '',
        channelId: '',
        channelType: null,
        code: null,
        groupCode: null,
        ig_botName: null,
        ig_name: null,
        joinAileLiffId: null,
        lineChannelType: null,
        liffId: null,
        memberId: null,
        messageRemainCount: null,
        messageTotalCount: null,
        messageUsedCount: null,
        name: null,
        pictureUrl: null,
        accessToken: null,
        avatarUrl: null,
        serviceNumberId: '',
        status: null,
        tenantId: null,
        bindErrorCode: null,
        bindErrorMessage: null,
        gwBindingDeleted: null,
        webhookUrl: '',
        groupName: null,
        allowLineGroupSend: null
      }
    };
    this.channelForm.reset();
    this.setupFormValidators(type);
    this.modalVisible = true;
  }

  getChannel(type: CHANNEL_TYPE): ChannelConfig | undefined {
    return this.getChannelByType(type);
  }

  // 关闭模态框
  closeChannelModal(): void {
    this.modalVisible = false;
    this.currentChannel = null;
    this.isViewMode = false;
    this.channelForm.reset();
    this.channelForm.enable(); // 重置表单状态
  }

  openLineGuide(): void {
    this.lineGuideVisible = true;
  }

  closeLineGuide(): void {
    this.lineGuideVisible = false;
  }

  // 复制 Webhook
  copyWebhook(channel: ChannelConfig): void {
    if (channel.config && channel.config.webhookUrl) {
      const textArea = document.createElement('textarea');
      textArea.value = channel.config.webhookUrl;
      document.body.appendChild(textArea);
      textArea.select();
      navigator.clipboard.writeText(channel.config.webhookUrl);
      document.body.removeChild(textArea);

      // 显示成功提示
      this.showSuccessAlert = true;

      // 5秒后自动隐藏
      setTimeout(() => {
        this.showSuccessAlert = false;
      }, 5000);
    } else {
      this.message.warning(this.i18n.fanyi('tenant.channel.personal.webhook-not-exist'));
    }
  }

  // 删除渠道
  deleteChannel(channel: ChannelConfig): void {
    if (channel.type === CHANNEL_TYPE.LINE_LOGIN) {
      this.unbindLineLogin();
    } else {
      this.unbindChannel(channel.type);
    }
  }
  private loadFacebookAppId(): void {
    this.systemConfigService.getFacebookAppId().subscribe({
      next: appId => {
        if (appId) {
          this.client_id = appId;
          console.log('Facebook App ID loaded:', appId);
        } else {
          console.warn('Facebook App ID not found in system config');
          this.message.warning(this.i18n.fanyi('tenant.channel.personal.facebook-app-id-not-found'));
        }
      },
      error: error => {
        console.error('Failed to load Facebook App ID:', error);
        this.message.error(this.i18n.fanyi('tenant.channel.personal.load-facebook-app-id-failed'));
      }
    });
  }

  loadChannelConfigs(): void {
    this.loading = true;
    const apiPath = ConstantUtil.TENANT_V1_PERSON_CHANNEL_LIST.replace('{id}', this.tenantId);
    this.httpService
      .post(apiPath, {})
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: res => {
          if (res.success && res.data) {
            // 新的数据结构处理
            this.updateChannelsFromNewStructure(res.data);
          } else {
            showFallbackHttpError(this.message, res.msg, this.i18n.fanyi('tenant.channel.personal.load-channel-config-failed'));
          }
        },
        error: error => {
          console.error('加载渠道配置失败:', error);
          this.message.error(this.i18n.fanyi('tenant.channel.personal.load-channel-config-failed'));
        }
      });
  }

  // 新的数据处理方法，适应新的数据结构
  updateChannelsFromNewStructure(serverData: { facebook?: any; instagram?: any; line?: any; lineLogin?: any }): void {
    this.channels = [];

    // 处理 Facebook 渠道
    if (serverData.facebook) {
      const facebookChannel = this.createChannelConfig(serverData.facebook, CHANNEL_TYPE.Facebook);
      if (facebookChannel) {
        this.channels.push(facebookChannel);
      }
    }

    // 处理 Instagram 渠道
    if (serverData.instagram) {
      const instagramChannel = this.createChannelConfig(serverData.instagram, CHANNEL_TYPE.Instagram);
      if (instagramChannel) {
        this.channels.push(instagramChannel);
      }
    }

    // 处理 Line OA 渠道
    if (serverData.line) {
      const lineChannel = this.createChannelConfig(serverData.line, CHANNEL_TYPE.LINE_OA);
      if (lineChannel) {
        this.channels.push(lineChannel);
      }
    }

    // 处理 Line Login 渠道
    if (serverData.lineLogin) {
      const lineLoginChannel = this.createChannelConfig(serverData.lineLogin, CHANNEL_TYPE.LINE_LOGIN);
      if (lineLoginChannel) {
        this.channels.push(lineLoginChannel);
      }
    }
  }

  // 创建渠道配置的辅助方法
  private createChannelConfig(data: any, channelType: CHANNEL_TYPE): ChannelConfig | null {
    if (!this.hasBoundChannelData(data, channelType)) return null;

    // 根据渠道类型确定 CHANNEL_TYPE
    let type: CHANNEL_TYPE = channelType;

    const channelConfig: ChannelConfig = {
      type: type,
      name: channelType,
      enabled: true,
      config: {
        businessCardLiffId: data.businessCardLiffId,
        botBasicId: data.botBasicId ?? null,
        channel: data.channel,
        channelId: data.channelId,
        channelType: data.channelType ?? null,
        code: data.code,
        groupCode: data.groupCode ?? null,
        ig_botName: data.ig_botName,
        ig_name: data.ig_name,
        providerId: data.providerId,
        channelSecret: data.channelSecret,
        joinAileLiffId: data.joinAileLiffId ?? null,
        lineChannelType: data.lineChannelType ?? data.channelType ?? null,
        liffId: data.liffId ?? null,
        memberId: data.memberId ?? null,
        messageRemainCount: data.messageRemainCount ?? null,
        messageTotalCount: data.messageTotalCount ?? null,
        messageUsedCount: data.messageUsedCount ?? null,
        name: data.name,
        pictureUrl: data.pictureUrl,
        accessToken: data.accessToken ?? null,
        avatarUrl: data.avatarUrl ?? null,
        serviceNumberId: data.serviceNumberId,
        status: data.status ?? null,
        tenantId: data.tenantId ?? null,
        bindErrorCode: data.bindErrorCode ?? null,
        bindErrorMessage: data.bindErrorMessage ?? null,
        gwBindingDeleted: data.gwBindingDeleted ?? null,
        webhookUrl: data.webhookUrl,
        groupName: data.groupName,
        allowLineGroupSend: data.allowLineGroupSend ?? null
      }
    };

    return channelConfig;
  }

  /** 切換個人租戶 LINE OA 的群組外發開關。 */
  onLineOaGroupSendChange(channel: ChannelConfig, eventOrChecked: MouseEvent | boolean): void {
    const previousValue = channel.config.allowLineGroupSend === true;
    const checked = typeof eventOrChecked === 'boolean' ? eventOrChecked : !previousValue;

    // nz-switch 會先更新自己的視覺狀態；確認或 API 完成前，模型必須維持已儲存的值。
    channel.config.allowLineGroupSend = previousValue;
    this.cdr.detectChanges();

    if (checked && !previousValue) {
      this.modal.confirm({
        nzTitle: '確認開啟 LINE 群組主動推送',
        nzContent: 'LINE 群組主動推送按群成員總人數扣除 LINE 點數額度，極易產生高額帳單。',
        nzOkText: '我已明確了解計費風險',
        nzCancelText: this.i18n.fanyi('tenant.channel.personal.cancel'),
        nzOnOk: () => this.saveLineOaGroupSendConfig(channel, true),
        nzOnCancel: () => {
          channel.config.allowLineGroupSend = previousValue;
          this.cdr.detectChanges();
        }
      });
      return;
    }
    this.saveLineOaGroupSendConfig(channel, checked);
  }

  isLineOaGroupSendAllowed(channel: ChannelConfig): boolean {
    return channel.config.allowLineGroupSend === true;
  }

  private saveLineOaGroupSendConfig(channel: ChannelConfig, allowLineGroupSend: boolean): void {
    this.lineGroupSendUpdating = true;
    this.channelService
      .updateLineGroupSendConfig(channel.config.serviceNumberId || this.serviceNumberId, allowLineGroupSend)
      .pipe(
        finalize(() => {
          this.lineGroupSendUpdating = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: res => {
          if (res.success) {
            channel.config.allowLineGroupSend = allowLineGroupSend;
            this.message.success('LINE 群組外發設定已更新');
          } else {
            channel.config.allowLineGroupSend = !allowLineGroupSend;
            this.message.error(res.msg || 'LINE 群組外發設定更新失敗');
          }
        },
        error: error => {
          channel.config.allowLineGroupSend = !allowLineGroupSend;
          this.message.error(error?.error?.msg || 'LINE 群組外發設定更新失敗');
        }
      });
  }

  private hasBoundChannelData(data: any, channelType: CHANNEL_TYPE): boolean {
    if (!data || typeof data !== 'object') {
      return false;
    }

    switch (channelType) {
      case CHANNEL_TYPE.LINE_OA:
      case CHANNEL_TYPE.LINE_LOGIN:
        return !!(data.channelId || data.providerId || data.serviceNumberId || data.status);
      case CHANNEL_TYPE.Facebook:
      case CHANNEL_TYPE.Instagram:
        return !!(data.code || data.channelId || data.serviceNumberId);
      default:
        return false;
    }
  }

  loginWithFacebook(type: string): void {
    if (!this.client_id) {
      this.message.warning(this.i18n.fanyi('tenant.channel.personal.facebook-app-id-not-set'));
      return;
    }

    localStorage.setItem('fb_binding_service_number_id', this.serviceNumberId);
    localStorage.setItem('fb_binding_service_channel', type);

    const baseScope = ['public_profile', 'email'];
    const pageScope = ['pages_show_list', 'pages_messaging', 'pages_manage_metadata'];
    const scope = [...baseScope, ...pageScope];

    const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('facebook_oauth_state', state);

    this.oauthUrl = this.facebookService.generateOAuthUrl(this.client_id, this.fbRedirect_url, scope, state);

    this.facebookLoginLoading = true;
    this.facebookService.openLoginPopup(this.oauthUrl);
  }

  // 提交绑定
  submitChannelConfig(): void {
    if (this.channelForm.invalid) {
      Object.values(this.channelForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return;
    }

    const formValue = this.channelForm.value;
    const channelType = this.currentChannel!.type;

    // 只处理 LINE OA 和 LINE Login 的绑定
    if (channelType === CHANNEL_TYPE.LINE_OA) {
      const data = {
        serviceNumberId: this.serviceNumberId,
        lineDto: {
          ...formValue,
          serviceNumberId: this.serviceNumberId
        },
        channelType: 'Line'
      };

      this.bindingLoading = true;
      this.bindingChannelType = 'LINE OA';
      this.channelService
        .bindChannel(data)
        .pipe(
          finalize(() => {
            this.loading = false;
            this.bindingLoading = false;
          })
        )
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.message.success(this.getChannelSubmittedMessage());
              this.modalVisible = false;
              setTimeout(() => {
                this.loadChannelConfigs();
              }, 500);
            } else {
              showFallbackHttpError(this.message, res.msg, this.i18n.fanyi('tenant.channel.personal.line-oa-connect-failed'));
            }
          },
          error: error => {
            this.message.error(this.i18n.fanyi('tenant.channel.personal.line-oa-connect-failed'));
            this.errorReportComponent.showConnectionErrorModal();
          }
        });
    } else if (channelType === CHANNEL_TYPE.LINE_LOGIN) {
      this.bindingLoading = true;
      this.bindingChannelType = 'LINE Login';
      this.channelService
        .bindLineLogin(this.officialServiceNumberId, formValue.channelId, formValue.channelSecret, formValue.providerId)
        .pipe(
          finalize(() => {
            this.loading = false;
            this.bindingLoading = false;
          })
        )
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.message.success(this.getChannelSubmittedMessage());
              this.modalVisible = false;
              setTimeout(() => {
                this.loadChannelConfigs();
              }, 500);
            } else {
              showFallbackHttpError(this.message, res.msg, this.i18n.fanyi('tenant.channel.personal.line-login-connect-failed'));
            }
          },
          error: error => {
            this.message.error(this.i18n.fanyi('tenant.channel.personal.line-login-connect-failed'));
            this.errorReportComponent.showConnectionErrorModal();
          }
        });
    }
  }

  // 根据渠道类型设置表单验证器
  setupFormValidators(channelType: string): void {
    // 重置所有控件的验证器
    Object.keys(this.channelForm.controls).forEach(key => {
      this.channelForm.get(key)?.clearValidators();
      this.channelForm.get(key)?.updateValueAndValidity();
    });

    // 只为 LINE OA 和 LINE Login 设置验证器
    if (channelType === CHANNEL_TYPE.LINE_OA || channelType === CHANNEL_TYPE.LINE_LOGIN) {
      this.channelForm.get('providerId')?.setValidators([Validators.required]);
      this.channelForm.get('channelId')?.setValidators([Validators.required]);
      this.channelForm.get('channelSecret')?.setValidators([Validators.required]);
    }

    // 更新验证状态
    Object.keys(this.channelForm.controls).forEach(key => {
      this.channelForm.get(key)?.updateValueAndValidity();
    });
  }

  // 检查表单是否有效
  isFormValid(): boolean {
    if (!this.currentChannel) return false;
    if (this.currentChannel.type === CHANNEL_TYPE.LINE_OA || this.currentChannel.type === CHANNEL_TYPE.LINE_LOGIN) {
      return this.channelForm.valid;
    }
    return true;
  }
  getChannelName(channel: ChannelConfig): string {
    if (channel.type === CHANNEL_TYPE.Instagram) {
      return channel.config.ig_name || channel.config.channelId;
    } else {
      return channel.config.name || channel.config.channelId;
    }
  }

  getChannelIcon(type: CHANNEL_TYPE): string {
    const iconMap: { [key in CHANNEL_TYPE]: string } = {
      [CHANNEL_TYPE.LINE_OA]: './assets/images/channels/icon-im-line.svg',
      [CHANNEL_TYPE.LINE_LOGIN]: './assets/images/channels/icon-im-line.svg',
      [CHANNEL_TYPE.Facebook]: './assets/images/channels/icon-im-fb.svg',
      [CHANNEL_TYPE.Instagram]: './assets/images/channels/icon-im-ig.svg',
      [CHANNEL_TYPE.UNDEFINED]: ''
    };
    return iconMap[type] ?? '';
  }
  unbindChannel(
    channelType: CHANNEL_TYPE,
    options?: {
      showConfirm?: boolean;
      callback?: () => void;
      customTitle?: string;
      customContent?: string;
    }
  ): void {
    const { showConfirm = true, callback, customTitle, customContent } = options || {};

    // 执行解绑的核心逻辑
    // 修改 unbindChannel 方法中的 executeUnbind 函数
    const executeUnbind = () => {
      // 显示解绑开始提示
      this.unbindingLoading = true;
      this.unbindingChannelType = channelType;

      const apiChannelType = this.getApiChannelType(channelType);
      this.channelService
        .unbindChannel(this.serviceNumberId, apiChannelType)
        .pipe(
          finalize(() => {
            this.unbindingLoading = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: res => {
            if (res.success) {
              this.message.success(this.i18n.fanyi('tenant.channel.personal.channel-unbind-success', { channelType }));
              this.loadChannelConfigs();
              this.cdr.detectChanges();
              // 执行回调函数
              if (callback) {
                callback();
              }
            } else {
              showFallbackHttpError(
                this.message,
                res.msg,
                this.i18n.fanyi('tenant.channel.personal.channel-unbind-failed', { channelType })
              );
            }
          },
          // 添加错误处理
          error: error => {
            console.error(`${channelType} 渠道解除串接错误:`, error);
            this.message.error(this.i18n.fanyi('tenant.channel.personal.channel-unbind-failed', { channelType }));
          }
        });
    };

    // 如果需要显示确认对话框
    if (showConfirm) {
      this.modal.confirm({
        nzTitle: customTitle || this.i18n.fanyi('tenant.channel.personal.unbind-channel-title', { channelType }),
        nzContent: customContent ?? this.i18n.fanyi('tenant.channel.personal.unbind-confirm-content'),
        nzOkText: this.i18n.fanyi('tenant.channel.personal.confirm-unbind'),
        nzCancelText: this.i18n.fanyi('tenant.channel.personal.cancel'),
        nzIconType: 'info-circle',
        nzWidth: '480px',
        nzOnOk: executeUnbind
      });
    } else {
      // 直接执行解绑
      executeUnbind();
    }
  }
  private getApiChannelType(channelType: CHANNEL_TYPE): string {
    const apiTypeMap: { [key in CHANNEL_TYPE]: string } = {
      [CHANNEL_TYPE.LINE_OA]: 'Line',
      [CHANNEL_TYPE.LINE_LOGIN]: 'Line',
      [CHANNEL_TYPE.Facebook]: 'Facebook',
      [CHANNEL_TYPE.Instagram]: 'Instagram',
      [CHANNEL_TYPE.UNDEFINED]: ''
    };
    return apiTypeMap[channelType] ?? '';
  }
  // Line Login 專用解綁方法（保持獨立）
  unbindLineLogin(): void {
    // 檢查是否存在 Line OA 串接
    if (this.hasChannelType(CHANNEL_TYPE.LINE_OA)) {
      // 如果存在 Line OA 串接，顯示提示模態框
      this.modal.confirm({
        nzTitle: this.i18n.fanyi('tenant.channel.personal.unbind-line-login-first'),
        nzContent: `
          <p>${this.i18n.fanyi('tenant.channel.personal.unbind-line-login-warning')}</p>
          <p style="margin-top: 16px; color: #ff4d4f;">${this.i18n.fanyi('tenant.channel.personal.unbind-line-login-note')}</p>
        `,
        nzOkText: this.i18n.fanyi('tenant.channel.personal.confirm-unbind-line-oa'),
        nzCancelText: this.i18n.fanyi('tenant.channel.personal.cancel'),
        nzIconType: 'info-circle',
        nzWidth: '480px',
        nzOnOk: () => {
          this.unbindChannel(CHANNEL_TYPE.LINE_OA, {
            showConfirm: false,
            callback: () => {
              this.showLineLoginUnbindConfirm();
            }
          });
        }
      });
      return;
    }
    this.showLineLoginUnbindConfirm();
  }

  // 顯示 Line Login 解綁確認框
  private showLineLoginUnbindConfirm(): void {
    this.modal.confirm({
      nzTitle: this.i18n.fanyi('tenant.channel.personal.unbind-line-login-title'),
      nzContent: this.i18n.fanyi('tenant.channel.personal.unbind-confirm-content'),
      nzOkText: this.i18n.fanyi('tenant.channel.personal.confirm-unbind'),
      nzCancelText: this.i18n.fanyi('tenant.channel.personal.cancel'),
      nzIconType: 'info-circle',
      nzWidth: '480px',
      nzOnOk: () => {
        // 显示解绑开始提示
        this.unbindingLoading = true;
        this.unbindingChannelType = 'LINE Login';

        this.channelService
          .unbindLineLogin(this.officialServiceNumberId)
          .pipe(
            finalize(() => {
              this.unbindingLoading = false;
              this.cdr.detectChanges();
            })
          )
          .subscribe(res => {
            if (res.success) {
              this.message.success(this.i18n.fanyi('tenant.channel.personal.line-login-unbind-success'));
              this.loadChannelConfigs(); // 重新加載渠道配置
              this.cdr.detectChanges();
            } else {
              this.message.error(this.i18n.fanyi('tenant.channel.personal.line-login-unbind-failed'));
            }
          });
      }
    });
  }
  getModalTitle(): string {
    if (!this.currentChannel) return '';

    const action = this.isViewMode ? this.i18n.fanyi('common.view') : this.i18n.fanyi('common.connect');
    return `${action} ${this.currentChannel.name}`;
  }
  viewChannel(channel: ChannelConfig): void {
    this.isViewMode = true;
    this.currentChannel = { ...channel };

    // 根据渠道类型填充表单数据
    if (channel.type === CHANNEL_TYPE.LINE_OA || channel.type === CHANNEL_TYPE.LINE_LOGIN) {
      this.channelForm.patchValue({
        providerId: channel.config.providerId,
        channelId: channel.config.channelId,
        channelSecret: channel.config.channelSecret // 显示掩码
      });
    }

    // 禁用表单验证（查看模式不需要验证）
    this.channelForm.disable();
    this.modalVisible = true;
  }
  onDropdownVisibleChange(visible: boolean) {
    this.dropdownVisible = visible;
  }

  // Instagram登录相关方法
  private setupInstagramMessageListener(): void {
    window.addEventListener('message', this.boundInstagramMessageHandler);
  }

  private handleInstagramMessage(event: MessageEvent): void {
    if (event.origin !== window.location.origin) {
      return;
    }

    const data = event.data;
    if (!data?.type || !this.instagramMessageTypes.has(data.type)) {
      return;
    }

    // 防护1: 检查是否正在处理消息
    if (this.isProcessingMessage) {
      console.log('Instagram message processing in progress, ignoring duplicate message');
      return;
    }

    // 防护2: 生成消息ID并检查是否已处理过
    const messageId = this.buildMessageDedupKey(data, 'instagram');
    if (this.processedMessageIds.has(messageId)) {
      console.log('Instagram message already processed, ignoring duplicate:', messageId);
      return;
    }

    // 标记正在处理消息
    this.isProcessingMessage = true;
    this.processedMessageIds.add(messageId);

    try {
      if (data.type === 'INSTAGRAM_LOGIN_SUCCESS') {
        this.handleInstagramLoginSuccess(data.userData);
      } else if (data.type === 'INSTAGRAM_LOGIN_ERROR') {
        this.handleInstagramLoginError(data.error);
      }
    } finally {
      // 延迟重置处理状态，防止快速连续消息
      setTimeout(() => {
        this.isProcessingMessage = false;
      }, 500);
    }

    // 清理过期的消息ID（保留最近10分钟的记录）
    setTimeout(() => {
      this.processedMessageIds.delete(messageId);
    }, 600000);
  }

  loginWithInstagram(): void {
    this.instagramLoginLoading = true;

    // 设置Instagram登录所需的参数
    localStorage.setItem('ig_binding_service_number_id', this.serviceNumberId);
    localStorage.setItem('ig_binding_service_channel', 'Instagram');

    const scope = [
      'instagram_business_basic',
      'instagram_business_manage_messages',
      'instagram_business_manage_comments',
      'instagram_business_content_publish'
    ];
    const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('instagram_oauth_state', state);

    // 使用定义的重定向URL生成OAuth URL
    this.instagramService.generateInstagramOAuthUrl(this.igRedirect_url, scope, state).subscribe({
      next: oauthUrl => {
        // 打开登录弹窗
        sessionStorage.setItem('parent_origin', window.location.origin);
        this.facebookService.openLoginPopup(oauthUrl);
        // 监听弹窗关闭
        const checkClosed = setInterval(() => {
          if (this.instagramLoginPopup?.closed) {
            clearInterval(checkClosed);
            this.instagramLoginLoading = false;
            this.cdr.detectChanges();
          }
        }, 1000);
      },
      error: error => {
        console.error('生成Instagram OAuth URL失败:', error);
        this.message.error(this.i18n.fanyi('tenant.channel.login-url-failed'));
        this.instagramLoginLoading = false;
      }
    });
  }

  private handleInstagramLoginSuccess(userData: InstagramUser): void {
    this.instagramLoginLoading = false;
    this.message.success(this.getChannelSubmittedMessage());

    // 关闭弹窗
    if (this.instagramLoginPopup && !this.instagramLoginPopup.closed) {
      this.instagramLoginPopup.close();
    }

    // 重新加载渠道配置
    this.loadChannelConfigs();
  }

  private handleInstagramLoginError(error: string): void {
    this.instagramLoginLoading = false;
    this.message.error(error || this.i18n.fanyi('tenant.channel.callback.instagram-auth-failed'));

    // 关闭弹窗
    if (this.instagramLoginPopup && !this.instagramLoginPopup.closed) {
      this.instagramLoginPopup.close();
    }
  }

  private buildMessageDedupKey(data: any, source: 'facebook' | 'instagram'): string {
    const baseParts = [source, data?.type ?? 'unknown', data?.channelType ?? '', data?.serviceNumberId ?? ''];

    if (data?.pageData?.id) {
      baseParts.push(String(data.pageData.id));
    }

    if (data?.userData?.id) {
      baseParts.push(String(data.userData.id));
    }

    if (data?.userData?.username) {
      baseParts.push(String(data.userData.username));
    }

    if (data?.message) {
      baseParts.push(String(data.message));
    }

    if (data?.error) {
      baseParts.push(String(data.error));
    }

    return baseParts.join('::');
  }

  get operationMaskVisible(): boolean {
    return this.bindingLoading || this.unbindingLoading;
  }

  get operationMaskText(): string {
    if (this.unbindingLoading && this.unbindingChannelType) {
      return this.i18n.fanyi('tenant.channel.personal.unbinding-channel', {
        channelType: this.getChannelDisplayName(this.unbindingChannelType)
      });
    }

    if (this.bindingLoading) {
      if (this.bindingChannelType === CHANNEL_TYPE.LINE_OA) {
        return this.i18n.fanyi('channel.connecting-line-oa');
      }

      if (this.bindingChannelType === CHANNEL_TYPE.LINE_LOGIN) {
        return this.i18n.fanyi('channel.connecting-line-login');
      }

      return this.i18n.fanyi('channel.connecting-channel').replace('{0}', this.getChannelDisplayName(this.bindingChannelType));
    }

    return this.i18n.fanyi('common.loading');
  }

  get operationMaskHintText(): string {
    return this.translateWithFallback('tenant.channel.personal.operation-mask-hint', 'common.loading');
  }

  private getChannelDisplayName(channelType: string): string {
    const channelNameMap: Record<string, string> = {
      [CHANNEL_TYPE.LINE_OA]: this.i18n.fanyi('tenant.channel.personal.line-oa-name'),
      [CHANNEL_TYPE.LINE_LOGIN]: this.i18n.fanyi('tenant.channel.personal.line-login-name'),
      [CHANNEL_TYPE.Facebook]: this.i18n.fanyi('tenant.channel.personal.facebook-name'),
      [CHANNEL_TYPE.Instagram]: this.i18n.fanyi('tenant.channel.personal.instagram-name'),
      Line: this.i18n.fanyi('tenant.channel.personal.line-oa-name')
    };

    return channelNameMap[channelType] ?? channelType;
  }

  private getChannelSuccessMessage(channelType: string): string {
    return `${this.getChannelDisplayName(channelType)} ${this.i18n.fanyi('channel.page-connect-success')}`;
  }

  private getChannelSubmittedMessage(): string {
    return this.i18n.fanyi('tenant.channel.personal.connect-submitted');
  }

  private getChannelFailureMessage(channelType: string): string {
    return `${this.getChannelDisplayName(channelType)} ${this.i18n.fanyi('channel.page-connect-failed')}`;
  }

  private translateWithFallback(key: string, fallbackKey: string): string {
    const translated = this.i18n.fanyi(key);
    if (translated && translated !== key) {
      return translated;
    }

    return this.i18n.fanyi(fallbackKey);
  }
}
